export default {
    'CTAT plugin': {
        // 'key': 'value',
    },
};